import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    roles = [],
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.perms.getRolePermsTree, {
        roles,
    }, options);
    if (error) return { error, status };
    return content || { rows: [] };
};
